import { Vue, Component, Prop } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";

@Component
export default class MealCard extends Vue {


    @Mutation SET_MEAL_INGREDIENTS
    @Mutation SET_CURRENT_MEAL

    @Prop() item: any;
    @Prop() Plate: any;
    @Prop() PlateId: any;
    @Prop() Count_id: any;
    openIngredientModal = false;

    _addPlate(Plate , PlateId , Count_id) {
        let path = '/mi-menu/platos'
        this.$router.push({
            path,
            query: { Menu:Plate, Id: PlateId , Day: Count_id}
        })
    }

    _onPlateAdded(item) {
        this.SET_CURRENT_MEAL(item)
        this.SET_MEAL_INGREDIENTS(item.items)
        this.$emit('openIngredientsModal', item)
    }

}